module.exports = __webpack_public_path__ + "img/IT0000442868399.5fec1952.png";